import className from "classnames";
import {
  GOVGR_LINK,
  GOVGR_PAGINATION__ITEM,
  GOVGR_PAGINATION__ITEM__CURRENT,
} from "../../../../../conf/styles/GovGrPagination";
import { ZERO } from "./paginationItemConstants";

const GovGrPaginationItem = ({
  currentPage = ZERO,
  index = ZERO,
  onPageChange,
}) => {
  let PaginationItemWrapperClass = className(GOVGR_PAGINATION__ITEM, {
    [GOVGR_PAGINATION__ITEM__CURRENT]: currentPage === index,
  });
  let SpanWrapperClass = className({ [GOVGR_LINK]: currentPage !== index });
  return (
    <li
      className={PaginationItemWrapperClass}
      onClick={() => onPageChange({}, index - 1)}
    >
      <span className={SpanWrapperClass}>{index}</span>
    </li>
  );
};

export default GovGrPaginationItem;
